import { EditSalesFunnelModal } from '@app/components/EditSalesFunnelModal/EditSalesFunnelModal.main';

export { EditSalesFunnelModal };
